import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { TokenChecker } from './modules/auth/services/token-checker.service';
import { TokenLoader } from './modules/auth/services/token-loader.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'evl-pca-frontend';

  constructor(
    private readonly tokenLoader: TokenLoader,
    private readonly tokenChecker: TokenChecker,
    private readonly router: Router,
    private readonly location: Location,
  ) {
    this.checkIfTokenActive();
  }

  ngOnInit(): void {
    this.loadToken();
  }

  private checkIfTokenActive() {
    if (
      this.tokenChecker.isTokenActive() &&
      this.location.path().includes('login')
    ) {
      this.router.navigate(['/analytics/overview']);
    }
  }

  private loadToken() {
    this.tokenLoader.run();
  }
}
